import { BillingTransactionType } from "@yedalabs/schema";
import { create } from "zustand";

type Step = "PaymentWall" | "PaymentForm";

export type AddFundsPayload = Record<
    BillingTransactionType,
    {
        amount: number;
        discount: number;
    }
>;

interface PaymentsStore {
    currentStep: Step;
    addFundsPayload: AddFundsPayload | null;
    paymentModalOpen: boolean;
    installments: number;
    setPaymentModalOpen: (
        open: boolean,
        step: Step,
        addFundsPayload?: AddFundsPayload | null
    ) => void;
    setInstallments: (n: number) => void;
    closePaymentModal: () => void;
}

export const usePayments = create<PaymentsStore>((set, get) => ({
    currentStep: "PaymentWall",
    addFundsPayload: null,
    paymentModalOpen: false,
    installments: 1,
    setPaymentModalOpen: (
        open: boolean,
        step: Step,
        addFundsPayload: AddFundsPayload | null = null
    ) =>
        set(() => ({
            paymentModalOpen: open,
            currentStep: step,
            addFundsPayload,
        })),
    setInstallments: (n: number) => set(() => ({ installments: n })),
    closePaymentModal: () => {
        set(() => ({
            paymentModalOpen: false,
            installments: 1,
        }));
    },
}));
